module.exports = __webpack_public_path__ + "assets/img/logo-stripe-singlepay.9d0f4bd6.png";